module.exports = __webpack_public_path__ + "static/CC-logo-01-077fb1bf85ea8f9faf46ba35dc3a099d.png";